import { OrderStatusId } from '@/network/graphql.g'

const ShippedOrderStatuses = [
  OrderStatusId.Shipped,
  OrderStatusId.ShippedWarehouse,
  OrderStatusId.Complete,
  OrderStatusId.CompleteGiftCard
]

const CompletedOrderStatuses = [
  OrderStatusId.Shipped,
  OrderStatusId.Canceled,
  OrderStatusId.CanceledReversal,
  OrderStatusId.Failed,
  OrderStatusId.CanceledSoldOut,
  OrderStatusId.CanceledOnRequest,
  OrderStatusId.CanceledByReturn,
  OrderStatusId.ShippedWarehouse,
  OrderStatusId.Promotional,
  OrderStatusId.Complete,
  OrderStatusId.CompleteGiftCard,
  OrderStatusId.CanceledByMerge
]

export const isOrderShipped = (statusId: OrderStatusId): boolean =>
  ShippedOrderStatuses.includes(statusId)

export const isOrderCompleted = (statusId: OrderStatusId): boolean =>
  CompletedOrderStatuses.includes(statusId)
